import userSlice from './authentication/authentication.slice'
import loaderSlice from './Loader/loader.slice'
import reportsSlice from './reports/reports.slice'
import uploadSlice from './upload/upload.slice'

const rootReducer = { user: userSlice, upload: uploadSlice, reports: reportsSlice, loader: loaderSlice }

export default rootReducer